import React from "react";

export const CreateIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 9.33333V12.6667C14.5 13.0203 14.3595 13.3594 14.1095 13.6095C13.8594 13.8595 13.5203 14 13.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V3.33333C2.5 2.97971 2.64048 2.64057 2.89052 2.39052C3.14057 2.14048 3.47971 2 3.83333 2H7.16667V3.33333H3.83333V12.6667H13.1667V9.33333H14.5Z"
        fill="#0F84FF"
      />
      <path
        d="M14.4999 4.66667H11.8333V2H10.4999V4.66667H7.83325V6H10.4999V8.66667H11.8333V6H14.4999V4.66667Z"
        fill="#0F84FF"
      />
    </svg>
  );
};
